export default "__VITE_ASSET__CmZsDOiw__";